import { EmailIcon, GlossaryIcon, HelpCenterIcon } from '@lokalise/louis'
import type { PropsWithChildren } from 'react'
import styles from './IrregularButtonLayout.module.css'

export const IrregularButtonLayout = ({ children }: PropsWithChildren) => {
  return (
    <div className={styles.container}>
      <div className={styles.legal}>
        <GlossaryIcon size="20px" color="var(--lok-color-text-link-default)" />
        Legal content
      </div>
      <div className={styles.blog}>
        <EmailIcon size="20px" color="var(--lok-color-text-link-default)" />
        Blog content profile
      </div>
      <div className={styles.button}>{children}</div>
      <div className={styles.support}>
        <HelpCenterIcon size="20px" color="var(--lok-color-text-link-default)" />
        Support centre content
      </div>
      <div className={styles.marketing}>
        <EmailIcon size="20px" color="var(--lok-color-text-link-default)" />
        Marketing content
      </div>
    </div>
  )
}
